/**
 * Created by zhj on 3/25/2016.
 */
'use strict';

angular.module('dashboard.pendingCommands', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('pendingCommandsWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.digitalOutputsWidget.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.digitalOutputsWidget.description';
          }
        },
        title: 'Pending Commands',
        description: 'Displays Pending Commands',
        controller: 'pendingCommandsCtrl',
        templateUrl: 'components/dashboard/pendingCommands/pendingCommandsWidget.tpl.html',
        isSingleInstance: true,
        config: {
          statusCodeList: [],
          vehicleList: [],
          vehicleGroup: null,
          vehicleGroupList: [],
          statusCode: null,
          noOfGridRows: '',
          height: 300
        }
      });
  }).service('pendingCommandsService', function (crudService) {
  this.getPendingCommandsList = function (statusCode, deviceId) {
    return crudService.customGET('portalcommands', 'pendingcommandslist/' + statusCode + '/' + deviceId);
  };
}).controller('pendingCommandsCtrl', function ($scope, widgetSettingsCreatorService, pendingCommandsService, commonTrackService, $translate, errorHandlingService) {
  var _deviceID = null;
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.pendingCommandComboBoxSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'status',
    selectedIndex: 0,
    change: function (event) {
      var args = event.args;
      if (args) {
        var statusCode = args.item.originalItem.status;
        if (statusCode && _deviceID) {
          loadPendingCommandsList(statusCode, _deviceID, false);
        }
      }
    },
    source: [{
      description: 'Pending',
      status: 0
    }]
  });

  $scope.customGridProperties = {
    height: '200px',
    pageable: false,
    columns: []
  };

  var loadPendingCommandsList = function (statusCode, deviceid, dataRefresh) {
    return pendingCommandsService.getPendingCommandsList(statusCode, deviceid).then(function (result) {
      if (result) {
        var dataSource;
        if (dataRefresh) {
          $scope.columnPropertiesList = result.gridSettings.overviewListGrids[0].columnProperties;
          $scope.customGridProperties.columns = commonTrackService.getColumnProperties(result.gridSettings.overviewListGrids[0].columnProperties, {}, {moduleName: 'pendingCommands'});
          var _additionalProperties = {translatedName: $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title')};
          $scope.pendingCommandsListGridSettings = commonTrackService.getGridSettings('pendingCommands', $scope.customGridProperties, null, _additionalProperties);
        }
        dataSource = result.dataList;
        $scope.pendingCommandsListGridSettings.source = dataSource;
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $scope.dataLoadingFinished = true;
    });
  };
  $scope.pendingCommandState = 0;
  $scope.$on('vehiclesListRowSelected', function (event, data) {
    if (!data) {
      $scope.isDataAvailable = false;
      return;
    }
    if (data.selectedRow) {
      $scope.isDataAvailable = true;
      loadPendingCommandsList($scope.pendingCommandState, data.selectedRow.deviceid, true);
      _deviceID = data.selectedRow.deviceid;
    } else {
      $scope.isDataAvailable = false;
    }
  });

  $scope.$on('pendingDashboardVehiclesRefreshed', function () {
    loadPendingCommandsList($scope.pendingCommandState, _deviceID, true);
  });

  $scope.$on('portalCommandSaved', function () {
    loadPendingCommandsList($scope.pendingCommandState, _deviceID, true);
  });
  $scope.$on('$destroy', function () {
    if ($scope.pendingCommandsListGridSettings && $scope.pendingCommandsListGridSettings.source) {
      delete  $scope.pendingCommandsListGridSettings.source;
    }
  });

});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/pendingCommands/pendingCommandsWidget.js